export default "__VITE_ASSET__CgxIJU2C__"